import { render, staticRenderFns } from "./SplashWindow.vue?vue&type=template&id=872fa37e&"
import script from "./SplashWindow.vue?vue&type=script&lang=js&"
export * from "./SplashWindow.vue?vue&type=script&lang=js&"
import style0 from "./SplashWindow.vue?vue&type=style&index=0&id=872fa37e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports